import { render, staticRenderFns } from "./RoleLevelsModalForm.vue?vue&type=template&id=653ca3c5&"
import script from "./RoleLevelsModalForm.vue?vue&type=script&lang=js&"
export * from "./RoleLevelsModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports